import React, { memo, useMemo, useRef, ReactNode } from 'react'
import { Modal } from '@mui/material'
import { CancelSmallMinor } from '@shopify/polaris-icons'
import tw from 'twin.macro'
import { FileViewerWithControls } from './FileViewerWithControls'

interface Props {
  isOpen?: boolean
  content?: ReactNode
  fullScreen?: boolean
  onClose(): void
  filePath?: string
  fileName?: string
  partnerDriverId?: string
  stepId?: string
  documentId?: string
  fileExtension?: string
  header?: React.ReactNode
}

const FileModalComponent = ({
  content,
  isOpen,
  fullScreen,
  onClose,
  filePath,
  fileName,
  partnerDriverId,
  stepId,
  documentId,
  fileExtension,
}: Props) => {
  const container = useMemo(() => document.getElementById('root'), [])
  const isPdf = fileExtension?.toLowerCase() === 'pdf'
  const modalContainerRef = useRef<HTMLDivElement>(null)

  return (
    <Modal
      container={container}
      open={Boolean(isOpen)}
      onClose={onClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
      css={tw`flex justify-center items-center backdrop-blur p-4 z-[13000]`}
    >
      <div
        ref={modalContainerRef}
        css={[
          tw`bg-[#EDEDED] rounded-lg w-[948px] max-h-[90vh] flex flex-col items-center overflow-hidden`,
          fullScreen && tw`h-full max-h-full`,
        ]}
      >
        <div
          css={tw`flex items-center justify-between self-stretch py-2 pr-2 pl-4 border-b border-[#EDEDED] bg-white flex-shrink-0`}
        >
          <h2 css={tw`text-sm font-bold text-black leading-[20px] m-0`}>Attached file</h2>
          <div
            css={tw`p-1 rounded bg-[#EDEDED] h-[28px] hover:bg-[#DAD9E0] active:bg-[#B4AFC0] cursor-pointer`}
            onClick={onClose}
            aria-label="Close"
          >
            <CancelSmallMinor width={20} height={20} />
          </div>
        </div>

        <div css={tw`flex-1 min-h-0 w-full overflow-hidden flex flex-col`}>
          {filePath ? (
            <FileViewerWithControls
              filePath={filePath}
              isPdf={isPdf}
              fileName={fileName}
              partnerDriverId={partnerDriverId}
              stepId={stepId}
              documentId={documentId}
              fileExtension={fileExtension}
              onClose={onClose}
            />
          ) : (
            content
          )}
        </div>
      </div>
    </Modal>
  )
}

export const FileModal = memo(FileModalComponent)
